const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-empty-pattern
  getResource({}, id) {
    return new Promise((resolve, reject) => {
      let url = "/api/resource/" + id;
      this._vm.$http
        .get(url)
        .then(res => {
          resolve(res.data.url);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
